import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Spinner } from '../components/ui/spinner';
import { ProtectedLayout } from '../components/protected-layout';
import { LoginPage } from '../modules/auth/login-page';
const DashboardPage = lazy(() => import('../modules/dashboard/dashboard-page').then((m) => ({ default: m.DashboardPage })));
import { EsteiraKanbanPage } from '../modules/esteira/kanban-page';
import { FinanceiroResumoPage } from '../modules/financeiro/resumo-page';
import { RelatoriosPage } from '../modules/relatorios/relatorios-page';
import { AptosRenovarPage } from '../modules/renovacoes/aptos-page';
import { DevolucoesPage } from '../modules/devolucoes/devolucoes-page';
import { UsuariosPage } from '../modules/usuarios/usuarios-page';
import { AcessosPage } from '../modules/usuarios/acessos-page';
import { ComissoesPage } from '../modules/comissoes/comissoes-page';
import { ImportacaoListaPage } from '../modules/importacao/lista-page';
import { ImportacaoDetalhePage } from '../modules/importacao/detalhe-page';
import { AssociadosListaPage } from '../modules/associados/lista-page';
import { AssociadoNovoPage } from '../modules/associados/novo-page';
import { SemMatchPage } from '../modules/associados/sem-match-page';
import { AssociadoDetalhePage } from '../modules/associados/detalhe-page';
import { ContratosListaPage } from '../modules/contratos/lista-page';
import { ContratoNovoPage } from '../modules/contratos/novo-page';
import { ContratoDetalhePage } from '../modules/contratos/detalhe-page';
import { InadimplenciaPage } from '../modules/inadimplencia/lista-page';
import { PagamentosListaPage } from '../modules/pagamentos/lista-page';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/" element={<Suspense fallback={<div className="flex justify-center py-20"><Spinner className="h-8 w-8" /></div>}><DashboardPage /></Suspense>} />
          <Route path="/esteira" element={<EsteiraKanbanPage />} />
          <Route path="/financeiro" element={<FinanceiroResumoPage />} />
          <Route path="/relatorios" element={<RelatoriosPage />} />
          <Route path="/aptos-renovar" element={<AptosRenovarPage />} />
          <Route path="/devolucoes" element={<DevolucoesPage />} />
          <Route path="/usuarios" element={<UsuariosPage />} />
          <Route path="/acessos" element={<AcessosPage />} />
          <Route path="/comissoes" element={<ComissoesPage />} />
          <Route path="/associados" element={<AssociadosListaPage />} />
          <Route path="/associados/novo" element={<AssociadoNovoPage />} />
          <Route path="/associados/sem-match" element={<SemMatchPage />} />
          <Route path="/associados/:id" element={<AssociadoDetalhePage />} />
          <Route path="/contratos" element={<ContratosListaPage />} />
          <Route path="/contratos/novo" element={<ContratoNovoPage />} />
          <Route path="/contratos/:id" element={<ContratoDetalhePage />} />
          <Route path="/inadimplencia" element={<InadimplenciaPage />} />
          <Route path="/pagamentos" element={<PagamentosListaPage />} />
          <Route path="/importacao" element={<ImportacaoListaPage />} />
          <Route path="/importacao/:id" element={<ImportacaoDetalhePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
